<template>
    <div>
        
        <navbar v-if="this.$store.getters.display_navbar_component"/>
        <sidenav v-if="this.$store.getters.display_sidenav_component"/>
    </div>
</template>

<script>

import { mapState } from 'vuex'
import { mapGetters } from 'vuex'
import { mapMutations } from 'vuex'
import { mapActions } from 'vuex'

import navbar from '@/components/navbar'
import sidenav from '@/components/sidenav'

export default {
    name: 'navigators',
    components:{
        navbar,
        sidenav
    },
    data(){
        return {
            show_navbar: false,
            show_sidenav: false
        }
    },
    computed: mapState(
						[
							'display_navigation_components',
							'display_navbar_component',
							'display_sidenav_component'
						]
					),
    mounted (){

    },
	watch: {
		display_navbar_component: function(val){
            console.log(val)
		},
        display_sidenav_component: function(val){
            console.log(val)
        }
	}
}
</script>

<style>

</style>


// WEBPACK FOOTER //
// src/components/navigators.vue